import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
    TextField, InputAdornment, IconButton, withStyles,
} from '@material-ui/core';
import { ReactComponent as AccountIcon } from 'assets/icons/AccountIcon.svg';
import { ReactComponent as LockOpenIcon } from 'assets/icons/LookIcon.svg';
import { ReactComponent as VisibilityOffIcon } from 'assets/icons/EyeBlockIcon.svg';
import { ReactComponent as VisibilityIcon } from 'assets/icons/EyeIcon.svg';

/**
 *@desc Estilos aplicados al input contenedor
 */
const CssTextField = withStyles({
    root: {
        '& label.Mui-focused': {
            color: '#E3E3E3',
        },
        '& .MuiInput-underline:after': {
            borderBottomColor: '#E3E3E3',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#E3E3E3',
            },
            '&:hover fieldset': {
                borderColor: '#E3E3E3',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#E3E3E3',
            },
        },
    },
})(TextField);

/**
 * @desc Compoenente para renderizar un input de manera generica
 * @param {*} param0
 */
const TextBase = React.forwardRef((
    {
        userLoginentry, passLoginentry,
        field: {
            name, value, onBlur, onChange, type = 'text',
        }, form: { touched, errors }, ...props
    }, ref,
) => {
    const hasError = touched[name] && Boolean(errors[name]);
    const [iconSecurity, setIconSecurity] = useState(true);
    // Setea un valor para mostrar o no icono en el input
    const iconInput = !!(userLoginentry || passLoginentry);
    const colorIcon = '#E02A58';

    // habilitan o no el icono de ojo
    const handleClickShowPassword = () => {
        setIconSecurity(!iconSecurity);
    };

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    return (
      <CssTextField
        id={name}
        inputRef={ref}
        variant="standard"
        type={iconSecurity ? 'password' : type}
        autoComplete="off"
        error={hasError}
        helperText={hasError && errors[name]}
        fullWidth
        name={name}
        onBlur={onBlur}
        onChange={onChange}
        value={value}
        margin="dense"
        InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                {Boolean(iconInput) && (
                    userLoginentry ? (
                      <AccountIcon style={{ color: colorIcon, fontSize: 18 }} />
                    ) : (
                      <LockOpenIcon style={{ color: colorIcon, fontSize: 18 }} />
                    )
                )}
              </InputAdornment>
            ),
            endAdornment: (
                passLoginentry ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                    >
                      { iconSecurity ? (
                        <VisibilityOffIcon style={{ color: colorIcon, fontSize: 18 }} />
                      ) : (
                        <VisibilityIcon style={{ color: colorIcon, fontSize: 18 }} />
                      ) }
                    </IconButton>
                  </InputAdornment>
                ) : null
            ),
        }}
        {...props}
      />
    );
});

TextBase.defaultProps = {
    ref: null,
    userLoginentry: false,
    passLoginentry: false,
};

TextBase.propTypes = {
    field: PropTypes.shape({
        name: PropTypes.string.isRequired,
        onBlur: PropTypes.func.isRequired,
        onChange: PropTypes.func.isRequired,
        type: PropTypes.string,
        value: PropTypes.oneOfType([
            PropTypes.string,
            PropTypes.number,
        ]).isRequired,
    }).isRequired,
    form: PropTypes.shape({
        touched: PropTypes.shape().isRequired,
        errors: PropTypes.shape().isRequired,
    }).isRequired,
    userLoginentry: PropTypes.bool,
    passLoginentry: PropTypes.bool,
    ref: PropTypes.func,
};

export default TextBase;
